import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setQuestionText } from 'features/productQuestionsAndAnswers/slice';

import { fetchSearchResults, emptySearchResults, newSearchResults } from '../questionsAndAnswersInstanceSlice';

import SearchBar from './SearchBar';

const ProductQuestionsAndAnswersSearch = ({ ...searchBarProps }) => {

	const {
		sortOrder, pageNumber, pageSize, searchTerm
	} = useSelector(
		(state) => state.productSearchUgc_QuestionsAndAnswers
	);
	const dispatch = useDispatch();
	const handleSearch = (searchText) => {

		if (!searchText) {

			dispatch(emptySearchResults());

		} else if (searchText !== searchTerm) {

			dispatch(newSearchResults(searchText));

		}

	};
	const onInputChange = (searchText) => {

		dispatch(setQuestionText(searchText));

	};

	useEffect(() => {

		if (searchTerm) {

			const payload = {
				shortSku: window.shortSku,
				searchTerm,
				sortOrder,
				pageSize,
				pageNumber
			};

			dispatch(fetchSearchResults(payload));

		}

	}, [ pageNumber, searchTerm ]);

	const handleClearSearch = () => {

		dispatch(emptySearchResults());

	};

	return (
		<SearchBar
			instance="questionsAndAnswers"
			handleClearSearch={handleClearSearch}
			handleSearch={handleSearch}
			onInputChange={onInputChange}
			searchTerm={searchTerm}
			labelText="Ask a question"
			showRightSearchIcon
			{...searchBarProps}
		/>
	);

};

export default ProductQuestionsAndAnswersSearch;
